/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { utils } from "./utils";
export class governmentInfo {
    static createLicenseValidation(errMsg, currentLocale) {
        utils.addValidationMethod("licenseValid", (value, element) => {
            if (value === "" && !utils.isRequired(element)) {
                return true;
            }
            else {
                const pattern = new RegExp(/^[A-Za-z0-9-*]*$/);
                return pattern.test(value);
            }
        }, errMsg[currentLocale].licenseFormat);
    }
    static createSsnValidation(errMsg, currentLocale, locale) {
        switch (currentLocale) {
            case locale.enUS:
            case locale.esUS:
            case locale.esCO:
            case locale.esCL:
                utils.addValidationMethod("ssnValid", (value, element) => {
                    if (value === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        const pattern = new RegExp(/^\d{3}-\d{2}-\d{4}$/);
                        if (pattern.test(value)) {
                            const arr = value.split("-").map(function (n) {
                                return parseInt(n, 10);
                            });
                            //https://secure.ssa.gov/poms.nsf/lnx/0110201035
                            return (arr[0] != 0 &&
                                arr[1] != 0 &&
                                arr[2] != 0 &&
                                arr[0] != 666);
                        }
                        else {
                            return false;
                        }
                    }
                }, errMsg[currentLocale].ssnFormat);
                break;
            case locale.enCA:
                utils.addValidationMethod("sinValid", (value, element) => {
                    if (value === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        const pattern = new RegExp(/^\d{3}-\d{3}-\d{3}$/);
                        if (pattern.test(value)) {
                            // The Luhn Algorithm.
                            var nCheck = 0, nDigit = 0, bEven = false;
                            value = value.replace(/\D/g, "");
                            for (let n = value.length - 1; n >= 0; n--) {
                                var cDigit = value.charAt(n), nDigit = parseInt(cDigit, 10);
                                if (bEven) {
                                    if ((nDigit *= 2) > 9) {
                                        nDigit -= 9;
                                    }
                                }
                                nCheck += nDigit;
                                bEven = !bEven;
                            }
                            return nCheck % 10 == 0;
                            //end Luhn Algorithm
                        }
                        else {
                            return false;
                        }
                    }
                }, errMsg[currentLocale].ssnFormat);
                break;
        }
    }
    static createRutValidation(errMsg, currentLocale) {
        utils.addValidationMethod("rutValid", function (value, element) {
            //XX.XXX.XXX-X or X.XXX.XXX-X or XXXXXXXX-X  or XXXXXXX-X
            const rutRegex = /^\d{1,2}\.?\d{3}\.?\d{3}-[\dkK]$/;
            if (!rutRegex.test(value))
                return false;
            const tmp = value.split("-");
            const checkDigit = tmp[1].toUpperCase();
            let rut = tmp[0].replace(/\./g, "");
            //process the rut from right to left, so reverse the string
            rut = rut.split("").reverse().join("");
            //this series repeats 2,3,4,5,6,7 over and over, but since RUT is
            //max 8 digits long we can just layout the maximum pattern
            const multiplier = [2, 3, 4, 5, 6, 7, 2, 3];
            let total = 0;
            for (let i = 0; i < rut.length; i++) {
                total += parseInt(rut[i]) * multiplier[i];
            }
            const modResult = total % 11;
            const modCheck = 11 - modResult;
            //Validate that the Mod equals the checkDigit
            switch (modCheck) {
                case 11:
                    return checkDigit == 0;
                case 10:
                    return checkDigit == "K";
                default:
                    return modCheck == checkDigit;
            }
        }, errMsg[currentLocale].rutFormat);
    }
    static createCpfValidation(errMsg, currentLocale) {
        utils.addValidationMethod("cpfValid", (value, element) => {
            if (value === "") {
                return !utils.isRequired(element);
            }
            // Test format
            const cpfRegex = /^([0-9]{3}\.?){3}-?[0-9]{2}$/;
            if (!cpfRegex.test(value)) {
                return false;
            }
            // Strip out the dot and dash
            value = value.replace(/[\\.-]/g, "");
            const firstCn = parseInt(value.substring(9, 10), 10);
            const secondCn = parseInt(value.substring(10, 11), 10);
            const checkResult = function (sum, cn) {
                let result = (sum * 10) % 11;
                if (result === 10 || result === 11) {
                    result = 0;
                }
                return result === cn;
            };
            const firstNum = value[0];
            if (value.split("").every((n) => n === firstNum)) {
                return false;
            }
            let sum = 0;
            for (var i = 1; i <= 9; i++) {
                sum = sum + parseInt(value.substring(i - 1, i), 10) * (11 - i);
            }
            if (!checkResult(sum, firstCn)) {
                return false;
            }
            sum = 0;
            for (i = 1; i <= 10; i++) {
                sum = sum + parseInt(value.substring(i - 1, i), 10) * (12 - i);
            }
            return checkResult(sum, secondCn);
        }, errMsg[currentLocale].cpfFormat);
    }
    static createCnpjValidation(errMsg, currentLocale) {
        utils.addValidationMethod("cnpjValid", (value, element) => {
            if (value === "") {
                return !utils.isRequired(element);
            }
            // Test format
            const cnpjRegex = /^[0-9]{2}\.?([0-9]{3}\.?){2}\/?[0-9]{4}-?[0-9]{2}$/;
            if (!cnpjRegex.test(value)) {
                return false;
            }
            // Strip out the dot and dash
            value = value.replace(/[\\.\-\\/]/g, "");
            const digits = Array.from(Array(14));
            for (let i = 0; i < 14; i++) {
                digits[i] = parseInt(value.charAt(i), 10);
            }
            // CNPJ Validation Algorithm
            const t1 = digits[0] * 5 +
                digits[1] * 4 +
                digits[2] * 3 +
                digits[3] * 2 +
                digits[4] * 9 +
                digits[5] * 8 +
                digits[6] * 7 +
                digits[7] * 6 +
                digits[8] * 5 +
                digits[9] * 4 +
                digits[10] * 3 +
                digits[11] * 2;
            const y1 = t1 % 11;
            const digit13 = digits[12];
            if ((y1 < 2 && digit13 !== 0) || (y1 >= 2 && digit13 !== 11 - y1)) {
                return false;
            }
            const t2 = digits[0] * 6 +
                digits[1] * 5 +
                digits[2] * 4 +
                digits[3] * 3 +
                digits[4] * 2 +
                digits[5] * 9 +
                digits[6] * 8 +
                digits[7] * 7 +
                digits[8] * 6 +
                digits[9] * 5 +
                digits[10] * 4 +
                digits[11] * 3 +
                digits[12] * 2;
            const y2 = t2 % 11;
            const digit14 = digits[13];
            if ((y2 < 2 && digit14 !== 0) || (y2 >= 2 && digit14 !== 11 - y2)) {
                return false;
            }
            return true;
        }, errMsg[currentLocale].cnpjFormat);
    }
    static createDniValidation(errMsg, currentLocale) {
        utils.addValidationMethod("dniValid", (value, element) => {
            if (utils.isRequired(element) && !value) {
                return false;
            }
            const dniField = document.querySelector("[data-dlron-type='dni']");
            if (dniField && dniField.value) {
                // Checks that the ID has 10 digits
                if (!/^\d{10}$/.test(value)) {
                    return false;
                }
                const digits = value.split("").map(Number);
                const province = digits.slice(0, 2).join("");
                if (province < 1 || province > 24) {
                    // The first two digits should be between 01 and 24 (province codes)
                    return false;
                }
                const thirdDigit = digits[2];
                if (thirdDigit < 0 || thirdDigit > 6) {
                    // The third digit should be between 0 and 6
                    return false;
                }
                // Modified Luhn algorithm
                let total = 0;
                const constants = [2, 1, 2, 1, 2, 1, 2, 1, 2];
                for (let i = 0; i < constants.length; i++) {
                    const product = digits[i] * constants[i];
                    total += product > 9 ? product - 9 : product;
                }
                const lastDigit = total % 10 === 0 ? 0 : 10 - (total % 10);
                // Compares the last digit with the check digit
                return lastDigit === digits[9];
            }
            return true;
        }, errMsg[currentLocale].dniFormat);
    }
    static createCedulaValidation(errMsg, currentLocale) {
        utils.addValidationMethod("cedulaValid", (value, element) => {
            if (utils.isRequired(element) && !value) {
                return false;
            }
            const cedulaField = document.querySelector("[data-dlron-type='cedula']");
            if (cedulaField && cedulaField.value) {
                const cedulaRegex = new RegExp(/^\d{6,8}$/);
                return cedulaRegex.test(value);
            }
            return true;
        }, errMsg[currentLocale].cedulaFormat);
    }
}
